import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import FiltersDropdown from 'feature/dispatching/components/FiltersDropdown';
import { useFilterCount, useUserRolePermissions } from 'hooks';
import { FilterCountChip } from 'feature/dispatching/components/FilterChips';

const TrailerControls = ({
  cardsFilters,
  defaultFiltersState,
  isLoading,
  isSuccess,
  onCreateTrailer,
  onViewTrailer,
  resetFilters,
  setCardsFilters,
  trailer,
}) => {
  const filtersRef = useRef();
  const [filtersOpened, setFiltersOpen] = useState(false);
  const { isDispatchingManage } = useUserRolePermissions();

  const openFilters = R.compose(setFiltersOpen, R.T);
  const closeFilters = R.compose(setFiltersOpen, R.F);

  // prettier-ignore
  const handleFilterChange = filter => R.compose(
    setCardsFilters,
    R.assoc(filter),
    R.path(['target', 'value'])
  );

  const { filterCount } = useFilterCount(cardsFilters, defaultFiltersState);

  // prettier-ignore
  const filtersIcon = filtersOpened
    ? <ExpandLessRoundedIcon position="right" variant="buttonsChild" />
    : <ExpandMoreRoundedIcon position="right" variant="buttonsChild" />

  return (
    <Box>
      <Button
        disabled={!isSuccess}
        onClick={openFilters}
        onClose={closeFilters}
        ref={filtersRef}
        sx={{ ml: 3 }}
        variant="text"
      >
        Filters
        {!!filterCount && <FilterCountChip count={filterCount} />}
        {filtersIcon}
      </Button>

      <Button
        disabled={!isSuccess}
        onClick={() => {
          onViewTrailer(trailer.trailerId);
        }}
        sx={{ '&, :hover': { boxShadow: 'none' }, ml: 3 }}
        variant="outlined"
      >
        View Trailer
      </Button>

      {isDispatchingManage && (
        <Button
          disabled={isLoading}
          onClick={onCreateTrailer}
          sx={{ '&, :hover': { boxShadow: 'none' }, ml: 3 }}
          variant="contained"
        >
          New Trailer
        </Button>
      )}

      <FiltersDropdown anchorEl={filtersRef.current} onClose={closeFilters} open={filtersOpened}>
        <TextField
          label="Location"
          name="Location"
          onChange={handleFilterChange('location')}
          value={cardsFilters.location}
        />
        {Boolean(cardsFilters.location) && (
          <Button onClick={resetFilters} sx={{ mt: 2 }} variant="text">
            Clear
          </Button>
        )}
      </FiltersDropdown>
    </Box>
  );
};

TrailerControls.propTypes = {
  cardsFilters: PropTypes.shape({
    location: PropTypes.string,
  }).isRequired,
  defaultFiltersState: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSuccess: PropTypes.bool.isRequired,
  onCreateTrailer: PropTypes.func.isRequired,
  onViewTrailer: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired,
  setCardsFilters: PropTypes.func.isRequired,
  trailer: PropTypes.shape({
    trailerId: PropTypes.string,
  }).isRequired,
};

export default TrailerControls;
